export * from './IconAxesRotate';
